import { render } from "./ChuGuiPage.vue?vue&type=template&id=60c44bbe&scoped=true"
import script from "./ChuGuiPage.vue?vue&type=script&lang=js"
export * from "./ChuGuiPage.vue?vue&type=script&lang=js"

import "./ChuGuiPage.vue?vue&type=style&index=0&id=60c44bbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c44bbe"]])

export default __exports__